// extracted by mini-css-extract-plugin
export var container = "_11-0";
export var disabled = "_11-4";
export var fullWidth = "_11-3";
export var lined = "_11-1";
export var selected = "_11-5";
export var tab = "_11-2";